import { render } from "./UserChangePassword.vue?vue&type=template&id=690a5081&scoped=true"
import script from "./UserChangePassword.vue?vue&type=script&lang=js"
export * from "./UserChangePassword.vue?vue&type=script&lang=js"

import "./UserChangePassword.vue?vue&type=style&index=0&id=690a5081&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690a5081"]])

export default __exports__